// extracted by mini-css-extract-plugin
export var category = "Cover-module--category--4b8dc";
export var cover = "Cover-module--cover--c8e33";
export var hasHeaderOffset = "Cover-module--hasHeaderOffset--5861a";
export var hasImage = "Cover-module--hasImage--18c38";
export var hasSpacer = "Cover-module--hasSpacer--0fb3b";
export var heading = "Cover-module--heading--b99be";
export var headingControl = "Cover-module--headingControl--9854e";
export var headingSecondary = "Cover-module--headingSecondary--b499e";
export var headingWrap = "Cover-module--headingWrap--26448";
export var image = "Cover-module--image--4fd7b";
export var inner = "Cover-module--inner--14d6e";
export var isCompact = "Cover-module--isCompact--fa8b8";
export var lead = "Cover-module--lead--588bc";
export var leadPrimary = "Cover-module--leadPrimary--a2f2c";
export var mip = "Cover-module--mip--46610";
export var noImage = "Cover-module--noImage--30b2f";
export var price = "Cover-module--price--506a7";
export var secondaryImage = "Cover-module--secondaryImage--73b9b";
export var themeNavy = "Cover-module--themeNavy--c5f2f";
export var themePlum = "Cover-module--themePlum--afa61";
export var themeTan = "Cover-module--themeTan--52ccc";